<script>
  import { fly } from 'svelte/transition';
  import { asnavigate } from '../Utils/asnavigation.js';
  import { useNavigate } from 'svelte-navigator';
  const navigate = useNavigate();
</script>

<div class="grid grid-cols-3 gap-4">
  <div in:fly="{{ delay: 100, x: 200, duration: 800 }}">
    <button
      on:click="{() =>
        asnavigate(navigate, '/process/particulier/coordonnees')}"
      class="as-btn-choix"
    >
      <div class="as-square-choix ">PARTICULIER</div>
    </button>
  </div>
  <div in:fly="{{ delay: 300, x: 200, duration: 800 }}">
    <button
      on:click="{() =>
        asnavigate(navigate, '/process/professionnel/coordonnees')}"
      class="as-btn-choix"
    >
      <div class="as-square-choix ">
        <div class="as-square-status">
          <div class="as-square-status">ENTREPRISE</div>
        </div>
      </div>
    </button>
  </div>
  <div in:fly="{{ delay: 500, x: 200, duration: 800 }}">
    <button
      on:click="{() =>
        asnavigate(navigate, '/process/negociant/identification')}"
      class="as-btn-choix"
    >
      <div class="as-square-choix ">
        <div class="as-square-status">NÉGOCIANT</div>
      </div>
    </button>
  </div>
</div>

<style>
  /* .as-square-choix {
    display: grid;
    place-items: center;
    outline: 4px solid #000;
    background: #f5f5f5;
    width: 250px;
    aspect-ratio: 1;
    font-family: 'introblack';
    font-size: 28px;
    transition: all 400ms;
  }
  .as-btn-choix:hover .as-square-choix {
    outline: 10px solid #000;
  } */
  .as-btn-rounded.as-btn-cancel {
    padding-left: 0;
    margin-top: 10px;
    cursor: pointer;
    color: #000;
    background-color: #fff;
    border-color: transparent;
    transition: none;
  }
  .as-modal-wrapper {
    padding: 25px;
  }
  .as-titre {
    font-family: 'introblack';
    color: #000;
    font-size: 35px;
  }
  @media only screen and (max-width: 768px) {
    .grid-cols-3 {
      grid-template-columns: repeat(1, minmax(0, 1fr));
      place-items: center;
      margin: 20px auto 35px;
    }
  }
</style>
